import { createContext, useState } from "react";

const hasData = () => {
    return localStorage.getItem('bearerToken') && localStorage.getItem('user')
}
export const getUser = () => {
    if (hasData()) {
        const token = localStorage.getItem("bearerToken");
        const user = JSON.parse(localStorage.getItem("user") || {});
        return { token, user }
    }
    return { token: false, user: false }
}


const UserContext = createContext(getUser());


export const useUserData = () => {
    const [userData, setUserData] = useState(getUser());

    const logOut = (callback=()=>{}) => {
        localStorage.removeItem("user")
        localStorage.removeItem("bearerToken")
        setUserData({ user: null, token: null })
        callback()
    }
    const logIn = (token, userData) => {
        localStorage.setItem("bearerToken", token)
        localStorage.setItem('user', JSON.stringify(userData))
        setUserData(getUser())
    }
    return { logIn, logOut, userData }
}

export const UserContextProvider = ({children}) => {
    const userState = useUserData()
    return (
        <UserContext.Provider value={userState} >
        {children}
        </UserContext.Provider>
    )
}

export default UserContext;
